/**
 * AvailabilityTypeItem.jsx
 * Created by Destin Frasier on 03/04/18.
 */

import React from 'react';
import PropTypes from 'prop-types';
import * as AvailabilityType from '../sharedComponents/availabilityTypes/AvailabilityType';

export default class AvailabilityTypeExamples extends React.Component {
    render() {
        if (!this.props.legendItems) {
            return (
                <div className="rec-availability-indicators">
                    <AvailabilityType.AvailabilityAvailable />
                    <AvailabilityType.AvailabilityWalkUp />
                    <AvailabilityType.AvailabilityLottery />
                    <AvailabilityType.AvailabilityUnavailable />
                </div>
            );
        }
        return (
            <div className="rec-availability-indicators">
                { this.props.legendItems.available &&
                    <AvailabilityType.AvailabilityAvailable />
                }
                { this.props.legendItems.availableNumber &&
                    <AvailabilityType.AvailabilityAvailableNumber />
                }
                { this.props.legendItems.walkup &&
                    <AvailabilityType.AvailabilityWalkUp />
                }
                { this.props.legendItems.lottery &&
                    <AvailabilityType.AvailabilityLottery />
                }
                { this.props.legendItems.unavailable &&
                    <AvailabilityType.AvailabilityUnavailable />
                }
                { this.props.legendItems.unavailableBlank &&
                    <AvailabilityType.AvailabilityUnavailableBlank />
                }
                { this.props.legendItems.availableBridged &&
                    <AvailabilityType.AvailabilityBridged />
                }
            </div>
        );
    }
}

AvailabilityTypeExamples.propTypes = {
    legendItems: PropTypes.shape({
        available: PropTypes.bool,
        availableNumber: PropTypes.bool,
        walkup: PropTypes.bool,
        lottery: PropTypes.bool,
        unavailable: PropTypes.bool,
        unavailableBlank: PropTypes.bool,
        availableBridged: PropTypes.bool
    })
};

AvailabilityTypeExamples.defaultProps = {
    legendItems: {
        available: false,
        availableNumber: false,
        walkup: false,
        lottery: false,
        unavailable: false,
        unavailableBlank: false,
        availableBridged: false
    }
};
